import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlertModal } from "@air/primitive-alert-modal";
import { Button } from "@air/primitive-button";
import { preSelectItemsAction, selectableItemsSelector } from "@air/redux-selected-items";
import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DeleteAssetMessageModalDescription } from "./DeleteAssetMessageModalDescription";
import { DeleteAssetMessageModalTitle } from "./DeleteAssetMessageModalTitle";
export const DeleteAssetMessageModal = (param)=>{
    let { onClose, children, ...restProps } = param;
    const dispatch = useDispatch();
    const selectableItems = useSelector(selectableItemsSelector);
    const leastDestructiveRef = useRef(null);
    const onDismiss = ()=>{
        // Pre-select the items that were ignored
        const selectedAssetIdClipIdMap = selectableItems.reduce((acc, selectableItem)=>{
            acc[selectableItem.item.assetId] = selectableItem.id;
            return acc;
        }, {});
        dispatch(preSelectItemsAction({
            itemsIds: restProps.ignoredAssetIds.map((assetId)=>selectedAssetIdClipIdMap[assetId]).filter(Boolean)
        }));
        onClose();
    };
    return /*#__PURE__*/ _jsxs(AlertModal, {
        "data-testid": "DELETE_ASSET_MESSAGE_MODAL",
        isOpen: restProps.removedAssetIds.length > 0 || restProps.ignoredAssetIds.length > 0,
        onDismiss: onDismiss,
        leastDestructiveRef: leastDestructiveRef,
        children: [
            /*#__PURE__*/ _jsx(DeleteAssetMessageModalTitle, {
                ...restProps,
                onDismiss: onDismiss
            }),
            /*#__PURE__*/ _jsx(DeleteAssetMessageModalDescription, {
                ...restProps
            }),
            children,
            /*#__PURE__*/ _jsx("div", {
                className: "-mx-6 -mb-6 flex justify-end gap-3 px-6 py-4",
                children: /*#__PURE__*/ _jsx(Button, {
                    appearance: "filled",
                    color: "blue",
                    "data-testid": "DELETE_ASSET_MESSAGE_MODAL_CTA",
                    onClick: onDismiss,
                    size: "large",
                    ref: leastDestructiveRef,
                    children: "Dismiss"
                })
            })
        ]
    });
};
